import { Component, OnInit } from '@angular/core';
import { PageComponent } from '@tytapp/common';

@Component({
  selector: 'app-sponsorship-toolkit',
  templateUrl: './sponsorship-toolkit.component.html',
  styleUrls: ['./sponsorship-toolkit.component.scss']
})
export class SponsorshipToolkitComponent extends PageComponent {
  init() {
    this.pageTitle = 'Gift Membership Packages Toolkit/FAQ';
  }

}
